// extracted by mini-css-extract-plugin
module.exports = {"cls1":"ColladaOverlayCine-ThreeJsOverlay-module--cls1--1OTV9","cls2":"ColladaOverlayCine-ThreeJsOverlay-module--cls2--1rU2b ColladaOverlayCine-ThreeJsOverlay-module--cls1--1OTV9"};